// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__pyrQz","edit":"styles_edit__bdo-W","icons":"styles_icons__GaNgF"};